import { Component, Input } from "@angular/core";
import { TranslocoDirective } from "@jsverse/transloco";
import { ProgressSpinnerModule } from "primeng/progressspinner";

/**
 * General purpose loader for pages where there is no actual template
 */
@Component({
  selector: "app-full-page-loader",
  imports: [ProgressSpinnerModule, TranslocoDirective],
  host: {
    class: "flex flex-auto w-full h-full",
  },
  template: `
    <ng-container *transloco="let t">
      <div class="flex flex-col justify-center items-center gap-4 w-full h-full min-h-screen">
        <p-progressSpinner [ariaLabel]="statusText" />
        @if (statusText) {
          <div class="text-gray-500 text-center">
            {{ statusText }}
          </div>
        }
      </div>
    </ng-container>
  `,
})
export class AppFullPageLoaderComponent {
  @Input() public statusText: string | undefined;
}
